<template>
  <div class="layout-wrapper">
    <header id="page-topbar" class="d-flex justify-content-between" style="padding: 16px 24px">
      <el-button class="n-btn" @click="$emit('btnBack', true)">
        Thoát
      </el-button>
      <div class="title">
        <slot name="title" />
      </div>
      <slot name="actions" />
    </header>
    <div class="content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.layout-wrapper {
  position: relative;
  .title{
    position: absolute;
    font-weight: 600;
    font-size: 24px;
    // margin: 0px;
    color: #23313e;
    cursor: pointer;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%)
    // align-self: center;
  }
  .content {
    margin-top: 5.5em;
    padding: 20px 16.6% 120px 16.6%;
    min-height: 80vh;
  }
}
</style>